export const photoCaptureUpdateAttachmentReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { attachmentInfo: action.payload });
};
//# sourceMappingURL=photoCaptureUpdateAttachmentReducer.js.map